import type { SelectOptionType } from "@ui/components/DEPRECATED_CustomSelect/selectOptions";

import type { IDeliveryLimits } from "@jti/magento";

export const getDeliveryLimitCitiesDropdownListV2 = (citiesList: IDeliveryLimits[] = []): SelectOptionType[] =>
  citiesList.map(({ name }) => ({
    label: name,
    value: name,
  }));
